module.exports = __webpack_public_path__ + "img/1f623.90a5625.svg";